import { Container, Row, Col } from "react-bootstrap";
import useMediaQuery from "../hooks/useMediaQuery";
import Typography from "./Typography/Typography";
import { useNavigate } from "react-router-dom";

const Banner = (props) => {
   const navigate = useNavigate();
   const lgBreakpoint = useMediaQuery("(min-width: 991px)");
   const backgroundStyles = {
      backgroundImage: `url(${props.image})`,
      minHeight: lgBreakpoint ? props?.height || "auto" : "auto",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
   };
   return (
      <Container fluid {...(lgBreakpoint ? { className: "banner-main" } : {})}>
         <Row style={backgroundStyles} className="justify-content-center align-items-center animation fadeIn">
            <Col xs={12} sm={12} md={10} lg={9} xl={9} className="text-center py-4 ">
               <h1 className={`fBold colorWhite mt-5 ${lgBreakpoint ? "fs60 display-3" : "display-5"}`} style={{ fontWeight: 600 }}>
                  {props.title}
               </h1>
               <span className={`mt30 mb30 mobMt10 mobMb10 colorWhite text-center px-5 ${lgBreakpoint ? "fs18" : "fs15"}`}>
                  {props.description &&
                     props.description.split("\n").map((text, idx) => (
                        <div key={`title-description-${idx}`}>
                           <Typography element="p" fontWeight={600} syne>
                              {text}
                           </Typography>
                        </div>
                     ))}
                  {props?.cta && (
                     <Typography element="p" fontWeight={600} syne>
                        <>
                           <span onClick={() => navigate("/get-in-touch")} style={{ textDecoration: "underline", cursor: "pointer" }}>
                              Let's Talk
                           </span>
                        </>
                     </Typography>
                  )}
               </span>
               {props?.extra && props?.extra}
            </Col>
         </Row>
      </Container>
   );
};

export default Banner;
